import {applyImageLightbox} from '../../modules/imageLightbox.js';
import {injectTableOfContents} from '../../modules/tableOfContentsInjector.js';
import '../../components/cards/course.js';

/** Initialize the page */
function initPage() {
    const topicContainer = document.querySelector('.js-publicationContent');
    if (topicContainer) {
        // Wait for TOC to be injected
        const tocContainer = injectTableOfContents(topicContainer, '.rteContent', 1);

        // Apply image lightbox to all images except isolated blocks
        applyImageLightbox([...topicContainer.querySelectorAll('img:not(.rteContent__isolatedBlock)')]);

        // Place the promotional quizzes CTA after the TOC
        const promotionalQuizzesCtaWrapper = document.querySelector('.js-promotionalQuizzesCtaWrapper');
        const promotionalQuizzesCta = promotionalQuizzesCtaWrapper?.querySelector('.js-promotionalQuizzesCta');
        if (promotionalQuizzesCtaWrapper && promotionalQuizzesCta && tocContainer) {
            tocContainer.after(promotionalQuizzesCtaWrapper);
            promotionalQuizzesCta.classList.remove('hidden');
            promotionalQuizzesCta.classList.add('flex');
        }
    }
}

document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initPage) : initPage();
